export default __webpack_public_path__ + "static/on-site-event-streaming-0bcaaeb1553b724122ce6cebd2dada38.jpg";